/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProductPreviews.vue?vue&type=template&id=4b108fa7&"
import script from "./ProductPreviews.vue?vue&type=script&lang=js&"
export * from "./ProductPreviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports